var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 1H3.33203C2.22746 1 1.33203 1.89543 1.33203 3V11.9352C1.33203 13.0398 2.22746 13.9352 3.33203 13.9352H13.999C15.1036 13.9352 15.999 13.0398 15.999 11.9352V3C15.999 1.89543 15.1036 1 13.999 1Z",
    stroke: "#3EB8AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76953 12.1665L5.40724 8.16453L9.12763 10.3738L14.2675 5.09082V12.1665H2.76953Z",
    fill: "#3EB8AA",
    stroke: "#3EB8AA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4835 4.13239C11.4835 4.60948 11.0968 4.99623 10.6197 4.99623C10.1426 4.99623 9.75586 4.60948 9.75586 4.13239C9.75586 3.65531 10.1426 3.26855 10.6197 3.26855C11.0968 3.26855 11.4835 3.65531 11.4835 4.13239Z",
    fill: "#3EB8AA",
    stroke: "#3EB8AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderimg);
export default __webpack_public_path__ + "static/media/placeholderimg.d2bfb06907000fef383da102856ca583.svg";
export { ForwardRef as ReactComponent };